import { UPDATE_HUB_CONNECTION } from "./actionTypes"

export const updateHubConnection = data => {
  return {
    type: UPDATE_HUB_CONNECTION,
    payload: data,
  }
}
